import { render, staticRenderFns } from "./VySearchBox.vue?vue&type=template&id=48996006&scoped=true&"
import script from "./VySearchBox.vue?vue&type=script&lang=js&"
export * from "./VySearchBox.vue?vue&type=script&lang=js&"
import style0 from "./VySearchBox.vue?vue&type=style&index=0&id=48996006&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48996006",
  null
  
)

export default component.exports